import { COLORS } from '../../../shared/config/colors/colors';
import { styled } from 'goober';
import { Typography } from '../../../shared/ui/typography/typography';
import { NavLinkScroll } from '@shared/ui/nav-link-scroll/nav-link-scroll';

export const LinkBackground = styled('div')`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    border-radius: 16px;
    background-color: transparent;
`;

export const StyledLink = styled(NavLinkScroll)`
    position: relative;
    display: flex;
    width: 100%;
    padding: 10px 12px;
    align-items: center;
    gap: 16px;
    color: ${COLORS.neutral_50};
    border-radius: 16px;

    &.active {
        color: ${COLORS.neutral_90};

        ${LinkBackground} {
            background-color: ${COLORS.neutral_05};
        }
    }
`;

export const IconWrapper = styled('div')`
    position: relative;
    display: flex;
    width: 28px;
    height: 28px;
    align-items: center;
    flex-shrink: 0;
    z-index: 1;
    svg {
        width: 100%;
        height: 100%;
    }
`;

export const StyledTypography = styled(Typography)`
    position: relative;
    flex-shrink: 0;
    z-index: 1;
`;
